import CampoTexto from "@/components/Formulario/CampoTexto";
import AlertBox from "@/components/layout/AlertBox";
import Grid, { GridItem } from "@/components/layout/Grid";
import { parseTelefone } from "@tera/shared/src/lib";
import { FormCamposProps } from "./FormCamposProps";

export const FormCamposWa360 = ({
    value,
    onChange,
    fieldErrors,
}: FormCamposProps) => {
    const [channelId, apiKey, phoneNumber] = value ? value.split(':') : [];

    return (
        <Grid>
            <GridItem sm={12} md={4}>
                <CampoTexto
                    readOnly
                    disabled
                    label="Telefone"
                    type="text"
                    defaultValue={parseTelefone(phoneNumber)}
                    autoFill="do-not-autofill-please"
                />
            </GridItem>
            <GridItem sm={12} md={8}>
                <AlertBox variant="info">
                    <span>
                        Para editar mais detalhes de canais Whatsapp, utilize a opção{' '}
                        <b>Gerenciar Whatsapp</b> do botão <b>Gerenciar canais</b>.
                    </span>
                </AlertBox>
            </GridItem>
        </Grid>
    );
};
